<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> IMPORTAÇÃO DE PRODUTOS </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-toolbar-title>SPF</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn outlined color="grey darken-3" @click="goToBackList()">
          <v-icon left>mdi-chevron-left</v-icon> Voltar
        </v-btn>
        <progress-bar :loading="loading" :inderterminate="loading" />
      </v-toolbar>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <alert
          :visible="successSave"
          type="success"
          :message="successMessage"
          :clickClose="() => (successSave = false)"
        />
        <v-container fluid>
          <v-row>
            <v-col cols="12" xs="12" md="3">
              <template>
                <v-file-input
                  prepend-icon="mdi-file-excel"
                  @change="onFilePicked"
                  label="Planilha"
                  outlined
                  dense
                ></v-file-input>
              </template>
            </v-col>
            <v-col cols="12" xs="12" md="2">
              <template>
                <v-file-input
                  prepend-icon="mdi-file-excel"
                  @change="onFilePickedPriceRede"
                  label="Preços Rede"
                  outlined
                  dense
                ></v-file-input>
              </template>
            </v-col>
            <v-col cols="12" xs="12" md="2">
              <template>
                <v-file-input
                  prepend-icon="mdi-file-excel"
                  @change="onFilePickedPriceMulti"
                  label="Preços Multi"
                  outlined
                  dense
                ></v-file-input>
              </template>
            </v-col>
            <v-col cols="12" xs="12" md="2">
              <v-btn color="blue darken-3" dark class="" @click="validate()">
                <v-icon left>mdi-cloud-upload-outline</v-icon> IMPORTAR
              </v-btn>
            </v-col>
            <v-col cols="12" xs="12" md="3" class="d-flex justify-end">
              <v-btn
                color="green darken-3 white--text"
                @click="handleConfirmImport()"
                :disabled="newProdutosArray.length === 0"
              >
                <v-icon left>mdi-check</v-icon> Confirmar Importação
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <alert
                :visible="!!error"
                :type="error"
                color="pink darken-1"
                :message="error"
                :clickClose="() => (error = '')"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-simple-table dense fixed-header class="border-table">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th
                        :colspan="11"
                        class="blue--text title font-weight-bold"
                      >
                        Fornecedor: {{ empresa.cnpj }} -
                        {{ empresa.nome }}
                      </th>
                    </tr>
                    <tr>
                      <th class="text-right" width="70">#</th>
                      <th width="250">Produto</th>
                      <th width="100">Coleção</th>
                      <th width="100">Tamanhos</th>
                      <th width="100">Unidade</th>
                      <th width="100">Categoria</th>
                      <th width="150">Preço Rede</th>
                      <th width="150">Preço Multimarcas</th>
                      <th width="300">Materiais/Cores</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in newProdutosArray"
                      :key="`${item.referencia}`"
                    >
                      <td class="text-right">{{ ++index }}</td>
                      <td>
                        <b>{{ item.referencia }}</b>
                        <br />
                        {{ item.nome }}
                        <br />
                        {{ item.colecao }}
                        <br />
                        <b>{{ item.tamanhos.join(", ") }}</b>
                      </td>
                      <td>
                        <v-select
                          :items="collections"
                          v-model="item.collection_id"
                          label="Coleção"
                          :item-text="(item) => `${item.name}`"
                          item-value="id"
                          hide-details
                          dense
                          outlined
                        ></v-select>
                      </td>
                      <td>
                        <v-select
                          :items="grids"
                          :item-text="
                            (item) =>
                              `${item.id} - ${item.sizes
                                .map((size) => size.size)
                                .join(' ')}`
                          "
                          item-value="id"
                          v-model="item.grid_id"
                          label="Grade"
                          dense
                          hide-details
                          outlined
                        ></v-select>
                      </td>
                      <td>
                        <v-select
                          :items="units"
                          v-model="item.unit_id"
                          label="Unidade"
                          :item-text="(item) => `${item.name}`"
                          item-value="id"
                          hide-details
                          dense
                          outlined
                        ></v-select>
                      </td>
                      <td>
                        <v-select
                          :items="categories"
                          v-model="item.category_id"
                          label="Categoria"
                          :item-text="(item) => `${item.name}`"
                          item-value="id"
                          hide-details
                          dense
                          outlined
                        ></v-select>
                      </td>
                      <td>
                        <v-text-field
                          v-mask="'money'"
                          class="text-field-uppercase"
                          v-model="item.price_cif"
                          dense
                          outlined
                          hide-details
                        ></v-text-field>
                      </td>
                      <td>
                        <v-text-field
                          v-mask="'money'"
                          class="text-field-uppercase"
                          v-model="item.price_multi"
                          dense
                          outlined
                          hide-details
                        ></v-text-field>
                      </td>
                      <td width="20%">
                        <div class="">
                          <div class="ma-3">
                            <div class="mb-0">
                              <table class="table-grid-cart">
                                <thead>
                                  <tr>
                                    <th width="50%">Material</th>
                                    <th width="50%">Cor</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="atributo in item.atributos"
                                    :key="`${atributo.cor_code}${atributo.material_code}`"
                                    class="text-left"
                                  >
                                    <td>
                                      <v-chip
                                        class="ma-2"
                                        :color="
                                          atributo.material_db
                                            ? 'blue'
                                            : 'green'
                                        "
                                        text-color="white"
                                        small
                                        label
                                      >
                                        <b>{{ atributo.material_code }}</b>
                                      </v-chip>
                                      -
                                      {{ atributo.material }}
                                    </td>
                                    <td>
                                      <v-chip
                                        class="ma-2"
                                        :color="
                                          atributo.cor_db ? 'blue' : 'green'
                                        "
                                        text-color="white"
                                        small
                                        label
                                      >
                                        <b>{{ atributo.cor_code }}</b>
                                      </v-chip>
                                      {{ atributo.cor }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
    <!-- <v-dialog v-model="dialogExample" width="90%" scrollable>
      <v-card>
        <v-card-title class="text-h5 green lighten-2" dark>
          XML PROCESSADO
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col>
              <v-data-table
                :headers="dessertHeaders"
                :items="produtos"
                item-key="nome"
                class="elevation-1"
              >
                <template v-slot:top>
                  <v-toolbar flat>
                    <v-toolbar-title
                      >Empresa: {{ empresa.cnpj }} -
                      {{ empresa.nome }}</v-toolbar-title
                    >
                    <v-spacer></v-spacer>
                  </v-toolbar>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogExample = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
  </div>
</template>

<script>
import { URL } from "@/api/config";
import Alert from "@/components/Alert";
import ProgressBar from "@/components/ProgressBar";

import * as CategoryAPI from "@/api/requests/CategoryRequest";
import * as CollectionAPI from "@/api/requests/CollectionRequest";
import * as UnitAPI from "@/api/requests/UnitRequest";
import * as GridAPI from "@/api/requests/GridRequest";

import AwesomeMask from "awesome-mask";

export default {
  components: {
    Alert,
    ProgressBar,
  },
  directives: {
    mask: AwesomeMask,
  },
  data: () => ({
    dessertHeaders: [
      {
        text: "Produto",
        align: "start",
        sortable: false,
        value: "nome",
      },
      { text: "Referencia", value: "referencia" },
      { text: "Tamanhos", value: "tamanhos" },
      { text: "Atributos", value: "eans" },
      { text: "", value: "data-table-expand" },
    ],
    expanded: [],
    produtos: [],
    newProdutosArray: [],
    collections: [],
    categories: [],
    units: [],
    grids: [],
    empresa: {
      cnpj: "",
      nome: "",
    },
    loading: false,
    error: "",
    company: "",
    companies: [],
    valid: true,
    lazy: false,
    dialogExample: false,
    successSave: false,
    successMessage: "",
    file: "",
    fileRede: "",
    fileMulti: "",
    errorXmlMessage: "",
    provider: {},
    rules: {
      required: (value) => !!value || "Campo Obrigatorio",
    },
    arraySubs: [],
  }),
  computed: {},
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      this.getCollections();
      // this.getCategories();
      this.getGrids();
      this.getUnits();
    },
    validate() {
      console.log(this.file);
      let form = new FormData();
      if (this.file === "" || this.file == undefined) {
        return false;
      }
      form.append("file", this.file);
      if (this.fileRede !== "") {
        form.append("fileRede", this.fileRede);
      }
      if (this.fileMulti !== "") {
        form.append("fileMulti", this.fileMulti);
      }
      this.xmlValidate(form);
      // if (this.$refs.form.validate()) {}
    },
    goToBackList() {
      this.$router.push({ name: "Product" });
    },
    onFilePicked(e) {
      this.file = e;
      this.errorXmlMessage = "";
    },
    onFilePickedPriceRede(e) {
      this.fileRede = e;
    },
    onFilePickedPriceMulti(e) {
      this.fileMulti = e;
    },
    async xmlValidate(data) {
      this.produtos = [];
      this.newProdutosArray = [];
      this.loading = false;
      try {
        let res = await fetch(`${URL}product-import/validate-excel`, {
          method: "POST",
          body: data,
        });
        if (res) {
          let response = await res.json();

          if (!response.status) {
            this.error = response.msg;
            return false;
          }

          this.empresa = { nome: response.fornecedor, cnpj: response.cnpj };
          this.provider = response.provider;
          this.produtos = response.produtos;

          let precoRede = response.preco_rede;
          let precoMulti = response.preco_multi;

          this.produtos = this.produtos.map((item) => {
            let precoR = 0;
            let precoM = 0;
            let index = precoRede.findIndex(
              (preco) => preco.referencia.trim() === item.referencia.trim()
            );
            let indexM = precoMulti.findIndex(
              (preco) => preco.referencia.trim() === item.referencia.trim()
            );
            if (index > -1) {
              precoR = precoRede[index].preco_rede;
            }
            if (indexM > -1) {
              precoM = precoMulti[index].preco_multi;
            }
            return {
              ...item,
              price_cif: precoR,
              price_multi: precoM,
            };
          });

          console.log(this.produtos);

          // let newProdutosArray = [];
          this.produtos.map((item) => {
            let index = this.newProdutosArray.findIndex(
              (prod) => prod.referencia === item.referencia
            );
            if (index > -1) {
              this.newProdutosArray[index].atributos.push({
                cor: item.cor,
                cor_code: item.cor_code,
                material: item.material,
                material_code: item.material_code,
                cor_db: item.cor_db,
                material_db: item.material_db,
                eans: item.eans,
                status: item.cor_db === null && item.material_db === null,
              });
            } else {
              this.newProdutosArray.push(item);
              let lastIndex = this.newProdutosArray.length - 1;
              this.newProdutosArray[lastIndex].category_id = "";
              this.newProdutosArray[lastIndex].collection_id = "";
              this.newProdutosArray[lastIndex].grid_id = "";
              this.newProdutosArray[lastIndex].subcategory_id = "";
              this.newProdutosArray[lastIndex].atributos = [
                {
                  cor: item.cor,
                  cor_code: item.cor_code,
                  material: item.material,
                  material_code: item.material_code,
                  cor_db: item.cor_db,
                  material_db: item.material_db,
                  eans: item.eans,
                  status: item.cor_db === null && item.material_db === null,
                },
              ];
            }
          });

          for (let index = 0; index < this.newProdutosArray.length; index++) {
            this.arraySubs.push([]);
          }

          this.getCategories(this.provider.provider_type_id);

          console.log(this.arraySubs);
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async getCollections() {
      // this.loadingCollections = true;
      this.collections = [];
      try {
        let data = await CollectionAPI.getAll();
        this.collections = data.sort((a, b) => (a.name > b.name ? 1 : -1));
      } catch (error) {
        this.collections = [];
        console.log(error);
      } finally {
        // this.loadingCollections = false;
      }
    },
    async getCategories(provider_type_id) {
      this.loadingCategories = true;
      this.categories = [];
      try {
        let data = await CategoryAPI.getAll(
          `?provider_type_id=${provider_type_id}`
        );
        this.categories = data.sort((a, b) => (a.name > b.name ? 1 : -1));
      } catch (error) {
        this.categories = [];
        console.log(error);
      } finally {
        this.loadingCategories = false;
        // this.loading = false;
      }
    },
    async getUnits() {
      // this.loadingUnit = true;
      try {
        let data = await UnitAPI.getAll();
        this.units = data.sort((a, b) => (a.name > b.name ? 1 : -1));
      } catch (error) {
        this.units = [];
      } finally {
        // this.loadingUnit = false;
      }
    },
    async getGrids() {
      // this.loadingGrid = true;
      try {
        let data = await GridAPI.getAll();
        this.grids = data.sort((a, b) => (a.id > b.id ? 1 : -1));
      } catch (error) {
        this.grids = {};
      } finally {
        // this.loadingGrid = false;
      }
    },
    async handleConfirmImport() {
      console.log(this.provider);
      console.log(this.newProdutosArray);
      this.loading = true;
      let data = {
        provider: this.provider,
        products: this.newProdutosArray,
      };
      try {
        let myHeaders = new Headers({
          "Content-Type": "application/json",
        });
        let res = await fetch(`${URL}product-import/save-excel`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        });
        let response = await res.json();
        if (response.status) {
          this.newProdutosArray = [];
          this.provider = {};
          this.produtos = [];

          this.empresa = { nome: "", cnpj: "" };
          this.provider = response.provider;
          this.produtos = response.produtos;
          this.fileMulti = "";
          this.fileRede = "";
          this.file = "";
          this.successSave = true;
          this.successMessage = response.msg;
        } else {
          this.error =
            "Problema ao confirmar importação, entre em contato com o suporte";
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.border-table {
  border: 1px solid #dddddd !important;
}
table th + th {
  border-left: 1px solid #dddddd;
}
table td + td {
  border-left: 1px solid #dddddd;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 12px;
}

.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 12px !important;
}

.border-bottom {
  border-bottom: 1px solid #ccc;
  margin-bottom: 2px;
}

.table-grid-cart {
  border-collapse: collapse;
  width: 100%;
}
.table-grid-cart > thead > tr > th,
.table-grid-cart > tbody > tr > td {
  padding: 3px;
  border: 1px solid black;
}
.table-grid-cart > tbody > tr > td {
  background-color: white !important;
}
.v-input__control {
  width: 100px !important;
}
</style>
